(function () {
  "use strict";

  if (window.SocialShareController) return;

  function handleClick(event) {
    const link = event.target.closest(".share-article .social");
    if (!link) return;

    const left = window.screen.width / 2 - 320;
    const top = window.screen.height / 2 - 320;
    window.open(
      link.getAttribute("href"),
      "social-share",
      `left=${left},top=${top},width=640,height=440,toolbar=0`,
    );
    event.preventDefault();
  }

  document.addEventListener("click", handleClick);
  window.SocialShareController = {
    destroy() {
      document.removeEventListener("click", handleClick);
      delete window.SocialShareController;
    },
  };
})();
